import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap"; // Import React-Bootstrap components
import FormalityHeader from "../../../components/header/FormalityHeader";
import { addToCart } from "../../../redux/actions/CartActions";
import "../../styles/flow-form.css";

const typesSector = [
  {
    code: "COM",
    name: "Commerce général",
    icon: "/images/activity-sector/commerce.png",
  },
  { code: "BTP", name: "BTP", icon: "/images/activity-sector/btp.png" },
  {
    code: "INF",
    name: "Services informatique",
    icon: "/images/activity-sector/informatique.png",
  },
  {
    code: "RES",
    name: "Restauration",
    icon: "/images/activity-sector/restauration.png",
  },
  {
    code: "IMM",
    name: "Activités immobilières (SCI)",
    icon: "/images/activity-sector/immobilier.png",
  },
  {
    code: "VTC",
    name: "Transport VTC",
    icon: "/images/activity-sector/transport.png",
  },
  {
    code: "ARG",
    name: "Agence de transfert d’argent",
    icon: "/images/activity-sector/argent.png",
  },
  {
    code: "VOY",
    name: "Agence de voyage",
    icon: "/images/activity-sector/voyage.png",
  },
  {
    code: "ENT",
    name: "Services aux entreprises",
    icon: "/images/activity-sector/entreprise.png",
  },
  {
    code: "FRE",
    name: "Consultation & Freelance",
    icon: "/images/activity-sector/freelance.png",
  },
  {
    code: "CAB",
    name: "Cabinet de conseil",
    icon: "/images/activity-sector/cabinet.png",
  },
  { code: "AUT", name: "Autre", icon: "/images/activity-sector/autre.png" },
];

function ImportationSectorActivity() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleSectorSelect = (code) => {
    dispatch(
      addToCart({
        sectorActivity: code,
      })
    );

    if (code === "AUT") {
      navigate("/importation-sector-activity-name");
    } else {
      navigate("/importation-business-name");
    }
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      {/* Title and Description */}
      <Container className="mt-4 text-center">
        <h4 className="text-2xl font-semibold">
          Quel est le{" "}
          <span style={{ color: "#FF5500" }}>secteur d'activité</span> de votre{" "}
          {cart?.businessType} ?
        </h4>
      </Container>

      {/* Displaying the sectors */}
      <Container className="mt-4 d-flex justify-content-center">
        <Row className="w-100" style={{ maxWidth: "1000px" }}>
          {typesSector.map((sector, index) => (
            <Col xs={12} sm={6} md={4} lg={2} className="mb-4" key={index}>
              <div
                className="sector-box d-flex flex-column align-items-center justify-content-center"
                onClick={() => handleSectorSelect(sector.code)}
                style={{
                  height: "150px",
                  border: "2px solid #ddd",
                  borderRadius: "8px",
                  padding: "20px",
                  cursor: "pointer",
                  transition: "border-color 0.3s",
                  textAlign: "center",
                  color: "#000",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#FF5500")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "#ddd")
                }
              >
                <img
                  src={sector.icon}
                  alt={sector.name}
                  style={{
                    width: "30px",
                    height: "30px",
                    marginBottom: "10px",
                  }}
                />
                <span style={{ fontSize: "0.8rem" }}>{sector.name}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default ImportationSectorActivity;
